/*
  Pfoten Chic – Legacy Konfiguratoren
  Version 4: schreibt Auswahl + Layer direkt in das echte Shopify-Formular
  UND speichert die Auswahl pro Produktseite im Browser.
  Für: Cord Comfort, TFG, Braided+, Tau
*/

(function () {
  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function getConfigurator() {
    return document.querySelector("#pc-cord-comfort, #pc-tfg, #pc-bp, #pc-t");
  }

  function getProductForm() {
    return (
      document.querySelector('product-form form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('form[id^="product-form-"]:not(.installment)')
    );
  }

  function storageKey(configurator) {
    var productKey = window.location.pathname || "product";
    var configuratorKey = configurator && configurator.id ? configurator.id : "legacy";
    return "pfotenchic-configurator-selection::" + productKey + "::" + configuratorKey;
  }

  function safeParse(json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      return null;
    }
  }

  function saveSelection(configurator) {
    if (!configurator || !window.localStorage) return;

    var data = {
      swatches: {},
      fields: {}
    };

    configurator.querySelectorAll(".pc-swatches").forEach(function (group, index) {
      var key = group.dataset.property || group.dataset.layer || "swatch_" + index;
      var active = group.querySelector(".pc-swatch.is-active");
      data.swatches[key] = active ? active.dataset.value || "" : "";
    });

    configurator.querySelectorAll(".pc-property").forEach(function (field, index) {
      var key = field.dataset.property || field.getAttribute("name") || field.id || "field_" + index;
      data.fields[key] = field.value || "";
    });

    try {
      window.localStorage.setItem(storageKey(configurator), JSON.stringify(data));
    } catch (error) {
      // localStorage kann z.B. im privaten Modus blockiert sein. Dann einfach ohne Speicherung weiterlaufen.
    }
  }

  function restoreSelection(configurator) {
    if (!configurator || !window.localStorage) return;

    var saved = null;

    try {
      saved = safeParse(window.localStorage.getItem(storageKey(configurator)));
    } catch (error) {
      saved = null;
    }

    if (!saved) return;

    if (saved.swatches) {
      configurator.querySelectorAll(".pc-swatches").forEach(function (group, index) {
        var key = group.dataset.property || group.dataset.layer || "swatch_" + index;
        var value = saved.swatches[key];

        if (!value) return;

        var match = null;

        group.querySelectorAll(".pc-swatch").forEach(function (swatch) {
          if ((swatch.dataset.value || "") === value) {
            match = swatch;
          }
        });

        if (!match) return;

        group.querySelectorAll(".pc-swatch").forEach(function (button) {
          button.classList.remove("is-active");
        });

        match.classList.add("is-active");
        updateSelectedLabel(group, match.dataset.value || "");

        if (group.dataset.layer && match.dataset.img) {
          var layer = document.getElementById(group.dataset.layer);
          if (layer) layer.src = match.dataset.img;
        }
      });
    }

    if (saved.fields) {
      configurator.querySelectorAll(".pc-property").forEach(function (field, index) {
        var key = field.dataset.property || field.getAttribute("name") || field.id || "field_" + index;
        if (Object.prototype.hasOwnProperty.call(saved.fields, key)) {
          field.value = saved.fields[key] || "";
        }
      });
    }
  }

  function setHiddenProperty(form, name, value) {
    if (!form || !name) return;

    var selectorName = "properties[" + name + "]";
    var input = form.querySelector('input[name="' + CSS.escape(selectorName) + '"]');

    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = selectorName;
      input.setAttribute("data-pc-dynamic-property", "true");
      form.appendChild(input);
    }

    input.value = value || "";
  }

  function clearDynamicProperties(form) {
    if (!form) return;
    form.querySelectorAll('input[data-pc-dynamic-property="true"]').forEach(function (input) {
      input.remove();
    });
  }

  function getSelectedItems(configurator) {
    var items = [];

    configurator.querySelectorAll(".pc-swatches").forEach(function (group) {
      var propertyName = group.dataset.property;
      var active = group.querySelector(".pc-swatch.is-active");
      var value = active ? active.dataset.value : "";

      items.push({
        property: propertyName,
        value: value,
        layer: group.dataset.layer || "",
        img: active ? active.dataset.img || "" : ""
      });
    });

    configurator.querySelectorAll(".pc-property").forEach(function (field) {
      items.push({
        property: field.dataset.property || field.getAttribute("name") || "Halsumfang",
        value: (field.value || "").trim(),
        layer: "",
        img: ""
      });
    });

    return items;
  }

  function getLayerOrder(configurator) {
    if (!configurator) return [];

    if (configurator.id === "pc-cord-comfort") {
      return ["cc-layer05", "cc-layer01", "cc-layer02", "cc-layer03", "cc-layer04"];
    }

    if (configurator.id === "pc-tfg") {
      return ["tfg-layer06", "tfg-layer01", "tfg-layer02", "tfg-layer03", "tfg-layer04", "tfg-layer05"];
    }

    if (configurator.id === "pc-bp") {
      return ["bp-layer07", "bp-layer01", "bp-layer02", "bp-layer03", "bp-layer04", "bp-layer05", "bp-layer06"];
    }

    if (configurator.id === "pc-t") {
      return ["t-layer06", "t-layer01", "t-layer02", "t-layer03", "t-layer04", "t-layer05"];
    }

    return [];
  }

  function updateLayersInPreview(configurator) {
    if (!configurator) return;

    configurator.querySelectorAll(".pc-swatches").forEach(function (group) {
      var active = group.querySelector(".pc-swatch.is-active");
      if (!active || !group.dataset.layer || !active.dataset.img) return;

      var layer = document.getElementById(group.dataset.layer);
      if (layer) {
        layer.src = active.dataset.img;
      }
    });
  }

  function writeLayerProperties(form, configurator) {
    var layerOrder = getLayerOrder(configurator);

    layerOrder.forEach(function (layerId, index) {
      var img = document.getElementById(layerId);
      var value = img ? img.getAttribute("src") || "" : "";

      var existing = document.getElementById("pc-cart-layer0" + (index + 1));
      if (existing) existing.value = value;

      setHiddenProperty(form, "_pc_layer0" + (index + 1), value);
    });
  }

  function writeVisibleProperties(form, configurator) {
    var selected = getSelectedItems(configurator);

    selected.forEach(function (item) {
      if (!item.property) return;
      setHiddenProperty(form, item.property, item.value);
    });
  }

  function updateSelectedLabel(group, value) {
    if (!group || !group.dataset.selectedTarget) return;

    var target = document.getElementById(group.dataset.selectedTarget);
    if (target) {
      target.textContent = value || "bitte wählen";
    }
  }

  function updateSummary(configurator) {
    var summary = configurator.querySelector("#pc-summary-text");
    if (!summary) return;

    var selected = getSelectedItems(configurator);
    var lines = selected
      .filter(function (item) {
        return item.property && item.value;
      })
      .map(function (item) {
        return "<div><strong>" + item.property + ":</strong> " + item.value + "</div>";
      });

    summary.innerHTML = lines.length ? lines.join("") : "Bitte wähle alle Optionen aus.";
  }

  function validate(configurator, showError) {
    var missing = false;

    configurator.querySelectorAll(".pc-swatches").forEach(function (group) {
      if (!group.querySelector(".pc-swatch.is-active")) {
        missing = true;
      }
    });

    configurator.querySelectorAll(".pc-property").forEach(function (field) {
      if (field.hasAttribute("required") && !(field.value || "").trim()) {
        missing = true;
      }
    });

    var errorBox = configurator.querySelector("#pc-error");
    if (errorBox) {
      errorBox.hidden = !(missing && showError);
    }

    return !missing;
  }

  function syncEverything(showError, shouldSave) {
    var configurator = getConfigurator();
    var form = getProductForm();

    if (!configurator || !form) return true;

    updateLayersInPreview(configurator);
    updateSummary(configurator);

    if (shouldSave) {
      saveSelection(configurator);
    }

    var valid = validate(configurator, showError);

    if (valid) {
      clearDynamicProperties(form);
      writeVisibleProperties(form, configurator);
      writeLayerProperties(form, configurator);
    }

    return valid;
  }

  ready(function () {
    var configurator = getConfigurator();
    if (!configurator) return;

    restoreSelection(configurator);
    syncEverything(false, false);

    // Swatch Auswahl
    document.addEventListener("click", function (event) {
      var sliderButton = event.target.closest(".pc-slider-btn");
      if (sliderButton) {
        var wrap = sliderButton.closest(".pc-slider-wrap");
        var slider = wrap ? wrap.querySelector(".pc-swatches-slider") : null;

        if (slider) {
          slider.scrollBy({
            left: sliderButton.classList.contains("pc-slider-next") ? 260 : -260,
            behavior: "smooth"
          });
        }

        return;
      }

      var swatch = event.target.closest("#pc-cord-comfort .pc-swatch, #pc-tfg .pc-swatch, #pc-bp .pc-swatch, #pc-t .pc-swatch");
      if (!swatch) return;

      var group = swatch.closest(".pc-swatches");
      if (!group) return;

      group.querySelectorAll(".pc-swatch").forEach(function (button) {
        button.classList.remove("is-active");
      });

      swatch.classList.add("is-active");

      if (group.dataset.layer && swatch.dataset.img) {
        var layer = document.getElementById(group.dataset.layer);
        if (layer) layer.src = swatch.dataset.img;
      }

      updateSelectedLabel(group, swatch.dataset.value || "");
      syncEverything(false, true);
    });

    // Textfelder
    document.addEventListener("input", function (event) {
      if (event.target.closest("#pc-cord-comfort, #pc-tfg, #pc-bp, #pc-t") && event.target.classList.contains("pc-property")) {
        syncEverything(false, true);
      }
    });

    // Direkt beim Button-Klick noch einmal schreiben, bevor Dawn den Warenkorb-Fetch macht
    document.addEventListener(
      "click",
      function (event) {
        var submitButton = event.target.closest('button[name="add"], button[type="submit"]');
        var configurator = getConfigurator();

        if (!submitButton || !configurator) return;

        if (!syncEverything(true, true)) {
          event.preventDefault();
          event.stopPropagation();
          return false;
        }
      },
      true
    );

    // Zusätzlich beim Submit in Capture-Phase
    document.addEventListener(
      "submit",
      function (event) {
        var configurator = getConfigurator();
        if (!configurator) return;

        if (!syncEverything(true, true)) {
          event.preventDefault();
          event.stopPropagation();
          return false;
        }
      },
      true
    );
  });
})();
